<template>
  <div id="app">
    <transition name="slide-left">
	    <router-view class="child-view"/>
	    <div class="main-loading" v-if="loadingShow">
	    	<div class="loadimg">
	    		
	    	</div>
	    </div>
    </transition>
  </div>
</template>
<script>
	import state from "@/store/modules/auth/index"
	import {mapState,mapMutations} from 'vuex'
	export default {
	  name: "App",
	  data() {
	    return {
	    	aaa:132,
	    	...{state}
	    };
	  },
	  computed: {
			...mapState(["loadingShow"])
		},
		mounted () {
			
		}
	}
</script>

<style lang="scss">
#app {
  width: 100vw;
  height:100%;
  overflow-x: hidden;
  -webkit-user-select: none;
	user-select: none;
	-webkit-touch-callout: none;
  .main-loading{
  	width:100%;
  	height:100%;
  	position: fixed;
  	left:0;
  	top:0;
  	z-index:400;
  	background:rgba(0,0,0,0.2);
  	.loadimg{
  		position: absolute;
  		top:50%;
  		left:0;
  		width:100%;
  		height:1.2rem;
  		margin-top:-1.2rem;
  		background:url("assets/imgs/home/otmsLoading.gif")no-repeat 0 0;
  		background-size: 100% 100%;
  	}
  }
}
.child-view {
    position: absolute;
    width: 100%;
    
    transition: all .6s cubic-bezier(.55, 0, .1, 1);
    -webkit-transition: all .6s cubic-bezier(.55, 0, .1, 1);
    -moz-transition: all .6s cubic-bezier(.55, 0, .1, 1);
    -o-transition: all .6s cubic-bezier(.55, 0, .1, 1);
    height: 100%;
}
.slide-left-enter,
.slide-right-leave-active {
    opacity: 0;
    -webkit-transform: translate3d(50px, 0, 0);
    transform: translate3d(50px, 0, 0);
    -moz-transition: translate3d(50px, 0, 0);
    -o-transition: translate3d(50px, 0, 0);
}

.slide-left-leave-active,
.slide-right-enter {
    opacity: 0;
    -webkit-transform: translate3d(50px, 0, 0);
    transform: translate3d(50px, 0, 0);
    -moz-transition: translate3d(50px, 0, 0);
    -o-transition: translate3d(50px, 0, 0);
}
</style>
